<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-pencil</v-icon>Editar produto
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="productName"
              :rules="nameRules"
              label="Nome do produto"
              required
              filled
            ></v-text-field>

            <v-text-field
              v-model="productPrice"
              :rules="priceRules"
              label="Preço do produto"
              required
              filled
            ></v-text-field>

            <v-text-field
                v-model="productCode"
                :rules="priceRules"
                label="Preço do produto"
                required
                filled
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="deep-purple lighten-2"
                text
                block
                @click="editProduct"
                :disabled="!valid"
                :loading="loading"
              >
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "OpenEditProduct",
  data: () => ({
    productName: "",
    productPrice: "",
    productCode: "",
    dialog: false,
    valid: true,
    index: Number,
    ref: Number,
    cat: String,
    nmb: Number,
    value: true,
    loading: false,
    nameRules: [
      v => !!v || "Nome é requerido",
      v => (v && v.length >= 3) || "Deve ter no mínimo 3 caracter"
    ],
    priceRules: [
      v => !!v || "Preço é requerido",
      v => (v && v.length >= 3) || "Deve ter no mínimo 3 caracter"
    ]
  }),
  methods: {
    editProduct() {
      if (this.$refs.form.validate() && this.index != null) {
        // alert(this.index);
        const payload = {
          productName: this.productName,
          productPrice: parseFloat(this.productPrice),
          productCategoryId: this.cat,
          ProductCodeExternal: this.productCode,
          productUUID: this.index
        };
        const value = {
          nmb: this.nmb,
          productName: this.productName,
          productPrice: this.productPrice
        };
        this.$store.dispatch("upRealTime", value);
        this.$store.dispatch("editProduct", payload);
      }
    }
  },
  created() {
    const self = this;
    eventBus.$on("openEditProduct", function(value) {
      self.dialog = value.dialog;
      self.index = value.index;
      // self.ref = value.ref;
      self.cat = value.cat;
      self.productName = value.name;
      self.productPrice = value.price;
      self.nmb = value.ind;
    });
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
